import React from 'react';
import PropTypes from 'prop-types';
import { getGlobalProps, setGlobalProps } from './utils/queryHelpers';
import GlobalProps from './GlobalProps/GlobalProps';
import _isEmpty from 'lodash/isEmpty';
import Auth from './Auth/Auth';
import { theme } from './components/Theme';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
// import _get from 'lodash/get';
import { STATUS_UPDATE_TIMEOUT } from './constants/constants';

export const AppContext = React.createContext();
export const AppConsumer = AppContext.Consumer;
const Authentication = new Auth();
const GP = new GlobalProps();
export class AppProvider extends React.Component {
  state = {
    showSidebar: true,
    showSearchbar: true,
    globalProps: getGlobalProps(),
    loaded: false,
    beaconBrandingId: 0,
    beaconLoaded: false,
    unassignedFiles: 0,
    unreadNotificationCount: 0,
    timerId: null
  };

  setSidebarVisible = showBar => {
    this.setState({ showSidebar: showBar });
  };
  setSearchbarVisible = showBar => {
    this.setState({ showSearchbar: showBar });
  };
  updateGlobalProps = newProps => {
    setGlobalProps(newProps);
    this.setState({ globalProps: newProps });
  };
  resyncGlobalProps = async () => {
    const { globalProps } = this.state;
    if (globalProps.currentOrgId) {
      const updatedProps = await GP.setupOrganization(
        globalProps.currentOrgId,
        globalProps,
        true
      );
      this.updateGlobalProps(updatedProps);
    }
  };
  getTheme = globalProps => {
    if (_isEmpty(globalProps) || _isEmpty(globalProps.branding)) {
      return theme;
    }

    const {
      frontendPrimaryColor,
      frontendPrimaryLightColor,
      frontendPrimaryDarkerColor,
      frontendSecondaryColor,
      frontendSecondaryLightColor,
      frontendSecondaryDarkerColor
    } = globalProps.branding;
    // Update theme with branding information
    theme.palette.primary.light = frontendPrimaryLightColor;
    theme.palette.primary.dark = frontendPrimaryColor;
    theme.palette.primary.main = frontendPrimaryColor;
    theme.palette.primary.darker = frontendPrimaryDarkerColor;
    theme.palette.secondary.light = frontendSecondaryLightColor;
    theme.palette.secondary.dark = frontendSecondaryColor;
    theme.palette.secondary.main = frontendSecondaryColor;
    theme.palette.secondary.mainDarker = frontendSecondaryDarkerColor;
    const brandedTheme = createMuiTheme({
      ...theme,
      overrides: {
        MuiFilledInput: {
          root: {
            backgroundColor: frontendPrimaryLightColor,
            '&:hover': {
              backgroundColor: frontendPrimaryLightColor
            },
            '&:focus': {
              backgroundColor: frontendPrimaryLightColor
            }
          }
        }
      }
    });
    return brandedTheme;
  };

  loadPendo = globalProps => {
    // init if not done already
    if (!window.pendo.visitorId) {
      window.pendo.initialize({
        visitor: {
          // It ids likely that we need to access the roleid from the userOrg record, but needs further dialog
          id: globalProps.user.id, // Required if user is logged in
          email: globalProps.user.loginEmail,
          firstName: globalProps.user.firstName,
          lastName: globalProps.user.lastName,
          role: globalProps.user.roleId

          // You can add any additional visitor level key-values here,
          // as long as it's not one of the above reserved names.
        },

        account: {
          id: globalProps.orgInfo.orgId, // Highly recommended
          name: globalProps.orgInfo.orgName
          // planLevel:    // Optional
          // planPrice:    // Optional
          // creationDate: // Optional

          // You can add any additional account level key-values here,
          // as long as it's not one of the above reserved names.
        }
      });
    }
    return;
  };

  loadBeacon = globalProps => {
    // const {
    //   subscriptionID,
    //   messagingEnabled,
    //   chatEnabled,
    //   messagingMode
    // } = globalProps.helpScout;
    // const { beaconLoaded } = this.state;
    // const orgName = _get(globalProps, 'orgInfo.orgName', 'Propel');
    // const orgId = _get(globalProps, 'orgInfo.orgId', 0);

    // // Destroy previous Beacon to load new
    // if (beaconLoaded) {
    //   window.Beacon('destroy');
    // }
    // window.Beacon('config', {
    //   messagingEnabled: messagingEnabled, //The "ask" section, includes email and chat
    //   chatEnabled: chatEnabled, //Enable or disable chat
    //   color: globalProps.branding.navigationColor,
    //   mode: messagingMode //how the beacon is presented, whether or not you want to drive to the chat or documents
    // });

    // // Initialize Beacon
    // window.Beacon('init', subscriptionID);
    // // Beacon loaded
    // this.setState({ beaconLoaded: true });

    // window.Beacon('identify', {
    //   name: globalProps.user.firstName + ' ' + globalProps.user.lastName,
    //   email: globalProps.user.loginEmail,
    //   company: orgName,
    //   jobTitle: globalProps.user.role,
    //   'User ID': globalProps.user.id,
    //   'Organization ID': orgId
    // });
    // return;
  };

  _updateStatuses = async GP => {
    if (!this.state.globalProps) {
      // when we are first attempting to log in we won't have globalProps defined yet.
      // That's OK, it'll get there, just get out of here for now.
      return;
    }
    const { currentOrgId } = this.state.globalProps;

    // if logged in as Propel admin only they won't have a current org ID so just
    // get out.  We'll let the timer run so that it's ready to go when an admin
    // switches orgs.
    if (!currentOrgId) {
      return;
    }
    const data = await GP.getSearchBarUpdates(currentOrgId);
    this.setState({
      unassignedFiles: data.shipment.unassignedFiles.totalCount,
      unreadNotificationCount: data.notificationLog.unreadNotificationCount
    });
  };

  resetUnreadNotificationCount = () => {
    this.setState({ unreadNotificationCount: 0 });
  };

  async componentDidMount() {
    const { globalProps } = this.state;
    const GP = new GlobalProps();
    if (_isEmpty(globalProps) && Authentication.isAuthenticated()) {
      // GP = new GlobalProps();
      try {
        const updatedProps = await GP.getProps();

        this.setState({ globalProps: updatedProps, loaded: true }, this.render);
      } catch (err) {
        // TODO got to figure out how we want to handle this failure
      }
    } else {
      this.setState({ loaded: true });
    }

    // set timer up to pull updates (file inbox/notifications)
    this._updateStatuses(GP);
    const timerId = setInterval(() => {
      this._updateStatuses(GP);
    }, STATUS_UPDATE_TIMEOUT * 1000);
    this.setState({ timerId });
  }

  componentWillUnmount() {
    const { timerId } = this.state;
    if (timerId) {
      clearInterval(timerId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { globalProps, beaconBrandingId } = this.state;
    // if we are authenticated, have global props
    if (Authentication.isAuthenticated() && !_isEmpty(globalProps)) {
      // If we haven't yet init'd pendo then do it
      // if (!window.pendo.visitorId){
      //   this.loadPendo(this.state.globalProps);
      // }
      // Validate that beacon was the right branding for the org
      if (beaconBrandingId !== globalProps.branding.id) {
        this.loadBeacon(globalProps);
        this.setState({ beaconBrandingId: globalProps.branding.id });
      }
      if (
        prevState.globalProps &&
        globalProps.currentOrgId !== prevState.globalProps.currentOrgId
      ) {
        // if they changed orgs just zero out the unassignedFile count and let
        // the timer update it next time it runs
        this.setState({ unassignedFiles: 0, unreadNotificationCount: 0 });
      }
    }
  }

  render() {
    const appTheme = this.getTheme(this.state.globalProps);
    return (
      this.state.loaded && (
        // MuiThemeProvider makes the theme available down the React tree
        // thanks to React context.
        <MuiThemeProvider theme={appTheme}>
          <CssBaseline />
          <AppContext.Provider
            value={{
              ...this.state,
              setSidebarVisible: this.setSidebarVisible,
              setSearchbarVisible: this.setSearchbarVisible,
              updateGlobalProps: this.updateGlobalProps,
              resyncGlobalProps: this.resyncGlobalProps
            }}
          >
            {this.props.children}
          </AppContext.Provider>
        </MuiThemeProvider>
      )
    );
  }
}

AppProvider.propTypes = {
  children: PropTypes.any
};
